import dayjs from 'dayjs';

import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IReview } from '../types';

interface Props {
  reviewData: IReview;
  isTLSelected?: boolean;
}
export const ProfileInfo = ({ reviewData, isTLSelected }: Props) => {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const reviewFrom = `${reviewData?.userReviewFrom?.firstName} ${reviewData?.userReviewFrom?.lastName}`;
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const reviewTo = `${reviewData?.usersReviewTo?.firstName} ${reviewData?.usersReviewTo?.lastName}`;
  const formatTime = dayjs(reviewData?.createdAt).format(' HH:mm A DD/MM/YYYY ');

  const fields = [
    Strings.field.reviewTo,
    Strings.field.reviewFrom,
    Strings.field.overallRating,
    Strings.field.dateAndTime,
  ];
  const data = [reviewTo ?? 'NA', reviewFrom ?? 'NA', reviewData?.overall ?? 'NA', formatTime];
  const TLRatings = [
    {
      heading: Strings.reviews.decisionMakingSkills,
      value: reviewData?.decisionMakingSkills,
      iconImg: 'ic_decisionMakingSkills',
    },
    {
      heading: Strings.reviews.leadershipSkills,
      value: reviewData?.leadershipSkills,
      iconImg: 'ic_leadershipSkills',
    },
    {
      heading: Strings.reviews.fairTreatment,
      value: reviewData?.fairTreatment,
      iconImg: 'ic_fairTreatment',
    },
  ];
  const TMRatings = [
    {
      heading: Strings.reviews.learningSkills,
      value: reviewData?.learningSkills,
      iconImg: 'ic_learningSkills',
    },
    {
      heading: Strings.reviews.projectInvolvement,
      value: reviewData?.projectInvolvement,
      iconImg: 'ic_participatingSkills',
    },
    {
      heading: Strings.reviews.taskPerformance,
      value: reviewData?.taskPerformance,
      iconImg: 'ic_taskPerformance',
    },
  ];
  const ratings = [
    {
      heading: Strings.reviews.behaviour,
      value: reviewData?.behavior,
      iconImg: 'ic_behaviour',
    },
    {
      heading: Strings.reviews.communicationSkills,
      value: reviewData?.communicationSkills,
      iconImg: 'ic_communicationSkills',
    },
    ...(isTLSelected ? TLRatings : TMRatings),
  ];
  return (
    <ProfileCard
      fields={fields}
      data={data}
      Src={reviewData?.usersReviewTo?.profileImage ?? reviewTo}
      title={Strings.profile.reviewInformation}
      desc={reviewData?.description}
      ratings={ratings}
    />
  );
};
